import PropTypes from 'prop-types';
// form
import {useFormContext, Controller} from 'react-hook-form';
// @mui
import {TextField} from '@mui/material';
import {toEnglishNumber} from "../../utils/formatNumber";
import {useTranslation} from "react-i18next";
import React from "react";


// ----------------------------------------------------------------------

export default function RHFQasedakShareField({valueName,sx, ...other}) {
    const {control, setValue, getValues} = useFormContext();

    return (
        <Controller
            name={valueName}
            control={control}
            render={({field, fieldState: {error}}) => (
                <TextField {...field} fullWidth error={!!error} helperText={error?.message} {...other}
                           value={getValues(valueName)}
                           sx={sx}
                           onChange={(event) => {
                               const onlyNums = event.target.value;
                                   if (!isNaN(onlyNums) &&  onlyNums >= 0 && onlyNums <= 100) {
                                       setValue(valueName, onlyNums)
                                   }
                           }}
                           inputProps={{
                            maxLength:3, 
                            minength:1,
                            inputMode: 'numeric',                   
                          }}
                />
            )}
        />
    );
}



